import React from 'react';

import { Container, Stripe } from './Burger.styles';

export const Burger = (props) => (
    <Container {...props}>
        <Stripe slim={props.slim} />
        <Stripe slim={props.slim} />
        <Stripe slim={props.slim} />
        <Stripe slim={props.slim} />
    </Container>
);
